<template>
  <div class="row supply-form">
    <div class="col-12">
      <div class="supply-form_title">
        <p>Заполните форму и мы свяжемся с вами</p>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="supply-form_controll">
        <label>Название вашей Организации<sup>*</sup></label>
        <SInput
          v-model="formData.organisationName"
          :error="!!formErrors.organisationName"
          :error-text="!!formErrors.organisationName ? formErrors.organisationName[0] : null"
          required
        />
      </div>
      <div class="supply-form_controll">
        <label>Укажите ИНН<sup>*</sup></label>
        <SInput
          v-model="formData.inn"
          :error="!!formErrors.inn"
          :error-text="!!formErrors.inn ? formErrors.inn[0] : null"
          placeholder="__ __ ______ __"
          mask="99 99 999999 99"
          required
        />
      </div>
      <div class="supply-form_controll">
        <label>Контактное лицо<sup>*</sup></label>
        <SInput
          v-model="formData.name"
          :error="!!formErrors.name"
          :error-text="!!formErrors.name ? formErrors.name[0] : null"
          required
        />
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="supply-form_controll">
        <label>Номер для связи<sup>*</sup></label>
        <SInput
          v-model="formData.phone"
          :error="!!formErrors.phone"
          :error-text="!!formErrors.phone ? formErrors.phone[0] : null"
          placeholder="+7(___)___-__-__"
          mask="+7(999)999-99-99"
          required
        />
      </div>
      <div class="supply-form_controll">
        <label>Ваше предложение<sup>*</sup></label>
        <STextArea
          v-model="formData.text"
          :error="!!formErrors.text"
          :error-text="!!formErrors.text ? formErrors.text[0] : null"
          required
        />
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="supply-form_controll supply-form_controll--file">
        <label :class="formErrors.doc ? 'error' : ''">Загрузите прайс-лист или<br>коммерческое предложение</label>
        <SFile
          id="price"
          v-model="formData.doc"
          name="price"
          label="Прикрепить файл"
          notice="Выберите файл с расширением (doc, docx, jpeg, png, xls, xlsx) и размером не превышающим 15 мб."
        />
      </div>
      <div class="supply-form_controll supply-form_controll--submit">
        <Button @click="sendCooperationForm" class="button_mid">
          Отправить на ознакомление
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import SInput from '@/components/UI/Smart/Input'
import STextArea from '@/components/UI/Smart/TextArea'
import SFile from '@/components/UI/Smart/File'
import Button from '@/components/UI/Button'
import ModalCheckDelivery from '@/components/page/Modal/ModalCheckDelivery'

export default {
  components: { SInput, STextArea, SFile, Button, ModalCheckDelivery },
  data () {
    return {
      formData: {
        organisationName: null,
        name: null,
        phone: null,
        inn: null,
        text: null,
        doc: null,
      },
    }
  },
  computed: {
    status () {
      return this.$store.getters['dictionaries/getStatus']
    },
    formErrors () {
      return this.$store.getters['dictionaries/getCooperationFormErrors']
    },
  },
  watch: {
    status (newValue) {
      switch (newValue) {
        case 'cooperation-form-successfully-fetched':
          this.formData = {
            organisationName: null,
            name: null,
            phone: null,
            inn: null,
            text: null,
            doc: null,
          }
          window.location.hash = 'supplier'
      }
    },
  },
  methods: {
    sendCooperationForm () {
      this.$store.dispatch('dictionaries/sendCooperationForm', this.formData)
    },
  },
}
</script>

<style lang="less">
.error {
	color: red;
}
.supply-form {
	align-items: flex-end;

	&_title {
		margin-bottom: 20px;

		@media screen and (max-width: 768px) { margin-bottom: 25px; }

		p {
			font-family: 'Roboto Slab', Arial, sans-serif;
			font-weight: 500;
			font-size: 25px;

			@media screen and (max-width: 768px) { text-align: center; }
		}
	}

	&_controll {
		margin-bottom: 28px;

		@media screen and (max-width: 768px) { margin-bottom: 20px; }

		label {
			display: block;
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 14px;
			line-height: 18px;
			margin-bottom: 13px;
		}

		.textarea {
			height: 150px;
			resize: none;
		}

		&--file {
			margin-bottom: 75px;
		}

		&--submit {
			display: flex;
			justify-content: center;

			.button {
				max-width: 100%;
				width: 300px;
			}
		}
	}
}
</style>
